import { jsx as _jsx } from "react/jsx-runtime";
import Eye from '@helsenorge/designsystem-react/components/Icons/Eye';
import NoEye from '@helsenorge/designsystem-react/components/Icons/NoEye';
import FrankensteinSharingStatus from '@helsenorge/designsystem-react/components/SharingStatus';
import useResources from '@helsenorge/framework-utils/resources/useResources';
import { getResources, Projects } from '../resources';
import styles from './styles.module.scss';
const SharingStatus = ({ classNames, selectedStatusType }) => {
    const resources = useResources(Projects.FRAMEWORK, getResources);
    if (!resources) {
        return null;
    }
    let sharingStatus = null;
    if (selectedStatusType === 'deltMedBarnet') {
        sharingStatus = (_jsx(FrankensteinSharingStatus, { icon: Eye, color: 'kiwi', className: styles['sharing-status-label'], children: resources.sharing_Status_Delt_Med_Barnet }));
    }
    if (selectedStatusType === 'bareSynligForDeg') {
        sharingStatus = (_jsx(FrankensteinSharingStatus, { icon: NoEye, color: 'cherry', className: styles['sharing-status-label'], children: resources.sharing_Status_Bare_Synlig_For_Deg }));
    }
    return _jsx("div", { className: classNames, children: sharingStatus });
};
export default SharingStatus;
